COUNTRY_MAP = {
    da: {
        currency: "DKK",
        country_code: "DK",
    },
    sv: {
        currency: "SEK",
        country_code: "SE",
    },
    fr: {
        currency: "EUR",
        country_code: "FR",
    },
    de: {
        currency: "EUR",
        country_code: "DE",
    },
    en: {
        currency: "EUR",
        country_code: "EN",
    },
    es: {
        currency: "EUR",
        country_code: "ES",
    },
    it: {
        currency: "EUR",
        country_code: "IT",
    },
};

$("#country-selector-toggle").on("click", function () {
    $("#country-selector-country-list").toggle();
});

$(".change-country").each(function () {
    let locale_code = $(this).data("locale-code");
    let country = COUNTRY_MAP[locale_code];
    $(this).data("country-code", country.country_code);
    $(this).find("#country-selector-currency").text(country.currency);
});

//language selector
$(".change-country").on("click", function (event) {
    event.preventDefault();
    $("#locale-code").val($(this).data("locale-code"));
    $("#country-code").val($(this).data("country-code"));
    $("#localization-form").submit();
});
